module.exports = __webpack_public_path__ + "img/beeline.d278c381.svg";